import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventsService } from 'src/app/services/events/events.service';

@Component({
  selector: 'app-confirm-redeem',
  templateUrl: './confirm-redeem.component.html',
  styleUrls: ['./confirm-redeem.component.less']
})
export class ConfirmRedeemComponent implements OnInit {
  @Input() data: any;
  private confirmRedeemObj = {
    referral_code: '',
    user_id: '',
    status: '',
    redeem_id: '',
    referral_ids: []
  };

  constructor(private ngbActiveMod: NgbActiveModal, private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService,
    private events: EventsService) { }

  ngOnInit() {
    this.setData();
  }

  // set up data
  private setData() {
    this.confirmRedeemObj.user_id = this.data.data.user_id;
    this.confirmRedeemObj.referral_code = this.data.data.refCode;
    this.confirmRedeemObj.redeem_id = this.data.data.redeem_id;
    this.confirmRedeemObj.referral_ids = this.data.data.referrals_ids;
  }

  // confirm the redeem
  // makes redeem set to verified || completed
  public confirmRedeem() {
    this.load.show();

    // set it to completed
    this.confirmRedeemObj.status = 'completed';

    this.admin.setRedeemStatus(this.confirmRedeemObj)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  // closes the modal
  public closeModal() {
    this.ngbActiveMod.close({ task: 'close modal', success: true });
  }

  // handle success
  public success(res) {
    if (res) {
      this.load.hide();

      this.msg.success(res);

      const user_id = this.confirmRedeemObj.user_id;

      this.events.triggerTableReload(user_id, 'redeem', 'confirm', this.confirmRedeemObj);
      this.ngbActiveMod.close({ task: 'close modal', success: true });
    }
  }

  // error
  public error(err) {
    this.load.hide();
    this.msg.error(err);
  }
}
